var cs = {
    ads: {
        ad: "Reklama",
        ads: "Reklamy",
        advertisement: "Reklama",
        indicator: "Reklamy"
    },
    audio: {
        button_txt: "Audio",
        menu_title: "Audio"
    },
    cc: {
        button: "CC",
        menu_title: "Titulky"
    },
    core: {
        exit_fullscreen: "Vypnout režim celé obrazovky",
        fullscreen: "Zapnout režim celé obrazovky",
        mute: "Vypnout zvuk",
        pause: "Pauza",
        play: "Přehrát",
        unmute: "Zapnout zvuk",
        volume: "Hlasitost"
    },
    ovp: {
        starting_in: "Odpočítavání"
    },
    playlist: {
        cancel: "Cancel",
        up_next: "Další",
        autoplay: "Automatické Přehrávání"
    },
    qsel: {
        menu_title: "Kvalita"
    },
    share: {
        clipboard_failure: "Přístup do schránky se nezdařil",
        clipboard_success: "Kód na stránku je nyní ve vaší schránce",
        embed: "Kód na stránku",
        link: "Odkaz",
        menu_title: "Sdílet"
    },
    speed: {
        menu_title: "Rychlost"
    }
};

var de = {
    ads: {
        ad: "Werbung",
        ads: "Werbung",
        advertisement: "Werbung",
        indicator: "Werbung"
    },
    audio: {
        button_txt: "Ton",
        menu_title: "Ton"
    },
    cc: {
        button: "CC",
        menu_title: "Untertitel",
        options: "Optionen",
        tracks: "Spuren",
        reset: "Zurücksetzen",
        colors: {
            Black: "Schwarz",
            Blue: "Blau",
            Cyan: "Türkis",
            Green: "Grün",
            Magenta: "Magenta",
            Red: "Rot",
            White: "Weiß",
            Yellow: "Gelb",
        },
        edgeStyle: {
            None: "Keiner",
            "Drop shadow": "Schlagschatten",
            Raised: "Erhaben",
            Depressed: "Gedrückt",
            Outline: "Umriss"
        },
        fontFamily: {
            "Monospaced Serif": "Monospaced Serif",
            "Proportional Serif": "Proportional Serif",
            "Monospaced Sans-Serif": "Monospaced Sans-Serif",
            "Proportional Sans-Serif": "Proportional Sans-Serif",
            Casual: "Locker",
            Cursive: "Kursiv",
        },
        properties: {
            fontFamily: "Schriftfamilie",
            fontSize: "Schriftgröße",
            fontColor: "Schriftfarbe",
            fontOpacity: "Schrifttransparenz",
            backgroundColor: "Hintergrundfarbe",
            backgroundOpacity: "Hintergrundtransparenz",
            characterEdgeStyle: "Textkantenstil",
        }
    },
    chromecast: {
        start: "Übertragung starten",
        stop: "Übetragung beenden"
    },
    core: {
        exit_fullscreen: "Vollbild verlassen",
        fullscreen: "Vollbild",
        mute: "Ton aus",
        pause: "Pause",
        play: "Abspielen",
        unmute: "Ton ein",
        volume: "Lautstärke"
    },
    ovp: {
        starting_in: "Countdown"
    },
    playlist: {
        cancel: "Abbrechen",
        up_next: "Nächste",
        autoplay: "Autoplay",
        now_playing: "Gerade läuft",
    },
    qsel: {
        menu_title: "Qualität"
    },
    share: {
        clipboard_failure: "Zugriff auf Zwischenablage fehlgeschlagen",
        clipboard_success: "Embedcode in die Zwischenablage kopiert",
        embed: "Einbetten",
        link: "Link",
        menu_title: "Teilen"
    },
    speed: {
        menu_title: "Geschwindigkeit"
    },
    vtsel: {
        button_txt: "Video",
        menu_title: "Videospur"
    }
};

var en = {
    ads: {
        ad: "Ad",
        ads: "Ads",
        advertisement: "Advertisement",
        indicator: "Ads",
        adchoices: "AdChoices"
    },
    audio: {
        button_txt: "Audio",
        menu_title: "Audio"
    },
    cc: {
        button: "CC",
        menu_title: "Subtitles",
        options: "Options",
        tracks: "Tracks",
        reset: "Reset",
        colors: {
            Black: "Black",
            Blue: "Blue",
            Cyan: "Cyan",
            Green: "Green",
            Magenta: "Magenta",
            Red: "Red",
            White: "White",
            Yellow: "Yellow",
        },
        edgeStyle: {
            None: "None",
            "Drop shadow": "Drop shadow",
            Raised: "Raised",
            Depressed: "Depressed",
            Outline: "Outline"
        },
        fontFamily: {
            "Monospaced Serif": "Monospaced Serif",
            "Proportional Serif": "Proportional Serif",
            "Monospaced Sans-Serif": "Monospaced Sans-Serif",
            "Proportional Sans-Serif": "Proportional Sans-Serif",
            Casual: "Casual",
            Cursive: "Cursive",
        },
        properties: {
            fontFamily: "Font family",
            fontSize: "Font size",
            fontColor: "Font color",
            fontOpacity: "Font opacity",
            backgroundColor: "Background color",
            backgroundOpacity: "Background opacity",
            characterEdgeStyle: "Character edge style",
        }
    },
    chromecast: {
        start: "start casting",
        stop: "stop casting",
    },
    core: {
        exit_fullscreen: "Exit fullscreen",
        fullscreen: "Fullscreen",
        mute: "Mute",
        muted: "Muted",
        pause: "Pause",
        play: "Play",
        seconds: "Seconds",
        timeline_aria_label: "Seek slider",
        unmute: "Unmute",
        volume: "Volume",
        close: "Close",
        "skip-next": "Next",
        "skip-prev": "Previous"
    },
    ovp: {
        starting_in: "Countdown"
    },
    playlist: {
        cancel: "Cancel",
        up_next: "Up next",
        autoplay: "Autoplay",
        now_playing: "Now playing",
        turn_off_autoplay: "Turn off autoplay",
        playlist: "Playlist"
    },
    qsel: {
        menu_title: "Quality"
    },
    share: {
        clipboard_failure: "Access to clipboard failed",
        clipboard_success: "The text is now on your clipboard",
        embed: "Embed",
        link: "Link",
        menu_title: "Share"
    },
    speed: {
        menu_title: "Speed"
    },
    vtsel: {
        button_txt: "Video",
        menu_title: "Video Track"
    }
};

var es = {
    ads: {
        ad: "Anúncio",
        ads: "Anúncios",
        advertisement: "Anúncio",
        indicator: "Anúncios"
    },
    audio: {
        button_txt: "Áudio",
        menu_title: "Áudio"
    },
    cc: {
        button: "CC",
        menu_title: "Subtítulos"
    },
    core: {
        exit_fullscreen: "Pantalla no completa",
        fullscreen: "Pantalla completa",
        mute: "Silenciar",
        pause: "Pausa",
        play: "Reproducir",
        unmute: "No silenciado",
        volume: "Volumen"
    },
    ovp: {
        starting_in: "Countdown"
    },
    playlist: {
        cancel: "Cancelar",
        up_next: "Siguiente",
        autoplay: "Reproducción Automática"
    },
    qsel: {
        menu_title: "Calidad"
    },
    share: {
        clipboard_failure: "Fallo en el acceso al portapapeles",
        clipboard_success: "El código de insercíon ahora está en tu portapapeles",
        embed: "Insertar",
        link: "Enlace",
        menu_title: "Compartir"
    },
    speed: {
        menu_title: "Velocidad"
    }
};

var fi = {
    ads: {
        ad: "Mainos",
        ads: "Mainos",
        advertisement: "Mainos",
        indicator: "Mainos"
    },
    audio: {
        button_txt: "Kieli",
        menu_title: "Kieli"
    },
    cc: {
        button: "CC",
        menu_title: "Tekstitys"
    },
    core: {
        exit_fullscreen: "Poistu kokonäytön tilasta",
        fullscreen: "Koko näytön tila",
        mute: "Vaimenna",
        pause: "Keskeytä",
        play: "Toista",
        unmute: "Poista vaimennus",
        volume: "Äänenvoimakkuus"
    },
    ovp: {
        starting_in: "Countdown"
    },
    playlist: {
        cancel: "Peruuta",
        up_next: "Seuraavaksi",
        autoplay: "Automaattinen Toisto"
    },
    qsel: {
        menu_title: "Laatu"
    },
    share: {
        clipboard_failure: "Leikepöydän käyttö epäonnistui",
        clipboard_success: "Kopioitu leikepöydälle",
        embed: "Upota",
        link: "Linkki",
        menu_title: "Jaa"
    },
    speed: {
        menu_title: "Nopeus"
    }
};

var fr = {
    ads: {
        ad: "Annonce",
        ads: "Annonces",
        advertisement: "Annonce",
        indicator: "Annonces"
    },
    audio: {
        button_txt: "Son",
        menu_title: "Son"
    },
    cc: {
        button: "CC",
        menu_title: "Sous-titres"
    },
    core: {
        exit_fullscreen: "Quitter le mode plein écran",
        fullscreen: "Plein écran",
        mute: "Sourdine",
        pause: "Pause",
        play: "Lecture",
        unmute: "Son activé",
        volume: "Volume"
    },
    ovp: {
        starting_in: "Compte à rebours"
    },
    playlist: {
        cancel: "Annuler",
        up_next: "Suivant",
        autoplay: "Lecture Automatique"
    },
    qsel: {
        menu_title: "Qualité"
    },
    share: {
        clipboard_failure: "L'accès au presse-papier a échoué",
        clipboard_success: "Le code embed est maintenant dans votre presse-papiers",
        embed: "Embed",
        link: "Lien",
        menu_title: "Partager"
    },
    speed: {
        menu_title: "Vitesse"
    }
};

var gr = {
    ads: {
        ad: "Διαφήμιση",
        ads: "Διαφήμισεις",
        advertisement: "Διαφήμιση",
        indicator: "Διαφήμισεις"
    },
    audio: {
        button_txt: "Ηχος",
        menu_title: "Κομμάτι ήχου"
    },
    cc: {
        button: "ΥΠ",
        menu_title: "Υπότιτλοι",
        options: "Επιλογες",
        tracks: "Κομματια",
        reset: "Επαναφορα",
        colors: {
            Black: "Μαυρο",
            Blue: "Μπλε",
            Cyan: "Γαλαζιο",
            Green: "Πρασσινο",
            Magenta: "Ροζ",
            Red: "Κοκκινο",
            White: "Λευκο",
            Yellow: "Κιτρινο",
        },
        edgeStyle: {
            None: "Κανενα",
            "Drop shadow": "Αναπτυσσομενη σκια",
            Raised: "Αναγλυφο",
            Depressed: "Πεπλατυσμενο",
            Outline: "Περιγραμμα"
        },
        fontFamily: {
            "Monospaced Serif": "Serif σταθερου πλατους",
            "Proportional Serif": "Serif αναλογικου πλατους",
            "Monospaced Sans-Serif": "Sans-Serif σταθερου πλατους",
            "Proportional Sans-Serif": "Sans-Serif αναλογικου πλατους",
            Casual: "Απλες",
            Cursive: "Λοξες",
        },
        properties: {
            fontFamily: "Οικογενεια γραμματοσειρων",
            fontSize: "Μεγεθος γραμματοσειρας",
            fontColor: "Χρωμα  γραμματοσειρας",
            fontOpacity: "Αδιαφανεια γραμματοσειρας",
            backgroundColor: "Χρωμα  φοντου",
            backgroundOpacity: "Αδιαφανεια φοντου",
            characterEdgeStyle: "Στιλ ακρων χαρακτηρα",
        }
    },
    core: {
        exit_fullscreen: "Έξοδος πλήρους οθονης",
        fullscreen: "Πλήρης οθόνη",
        mute: "Σίγαση",
        pause: "Παύση",
        play: "Αναπαραγωγή",
        unmute: "Κατάργηση σίγασης",
        volume: "Ενταση ήχου"
    },
    ovp: {
        starting_in: "Αντίστροφη μέτρηση"
    },
    playlist: {
        cancel: "Ακύρωση",
        up_next: "Επόμενο Βίντεο",
        autoplay: "Αυτόματη Αναπαραγωγή",
        now_playing: "Παίζει Τώρα"
    },
    qsel: {
        menu_title: "Ανάλυση εικόνας"
    },
    share: {
        clipboard_failure: "Η αντιγραφη της επιλογής απέτυχε",
        clipboard_success: "H επιλογή αντιγράφηκε επιτυχώς",
        embed: "Κώδικας Ενσωμάτωσης",
        link: "Σύνδεσμος",
        menu_title: "Κοινοποίηση"
    },
    speed: {
        menu_title: "Ταχύτητα"
    }
};

var he = {
    ads: {
        ad: "מודעה",
        ads: "מודעה",
        advertisement: "מודעה",
        indicator: "מודעה"
    },
    audio: {
        button_txt: "שֶׁמַע",
        menu_title: "שֶׁמַע"
    },
    cc: {
        button: "CC",
        menu_title: "כתוביות"
    },
    core: {
        exit_fullscreen: "צא ממסך מלא",
        fullscreen: "מסך מלא",
        mute: "לְהַשְׁתִיק",
        pause: "עצור",
        play: "נגן",
        unmute: "בטל השתקה",
        volume: "עוצמת שמע"
    },
    ovp: {
        starting_in: "ספירה לאחור"
    },
    playlist: {
        cancel: "לְבַטֵל",
        up_next: "הבא",
        autoplay: "הפעלה אוטומטית"
    },
    qsel: {
        menu_title: "איכות"
    },
    share: {
        clipboard_failure: "הגישה ללוח נכשלה",
        clipboard_success: "הטקסט נמצא כעת על הלוח שלך",
        embed: "לְשַׁבֵּץ",
        link: "קישור",
        menu_title: "לַחֲלוֹק"
    },
    speed: {
        menu_title: "מְהִירוּת"
    }
};

var nb = {
    ads: {
        ad: "Reklame",
        ads: "Reklame",
        advertisement: "Reklame",
        indicator: "Reklame"
    },
    audio: {
        button_txt: "Lydspor",
        menu_title: "Lydspor"
    },
    cc: {
        button: "CC",
        menu_title: "Teksting"
    },
    core: {
        exit_fullscreen: "Avslutt fullskjerm",
        fullscreen: "Fullskjerm",
        mute: "Skru av lyd",
        pause: "Pause",
        play: "Spill av",
        unmute: "Skru på lyd",
        volume: "Volum"
    },
    ovp: {
        starting_in: "Sendingen starter om"
    },
    playlist: {
        cancel: "Cancel",
        up_next: "Neste video",
        autoplay: "Automatisk Avspilling"
    },
    qsel: {
        menu_title: "Kvalitet"
    },
    share: {
        clipboard_failure: "Tilgang til utklippstavlen mislyktes",
        clipboard_success: "Teksten er nå på utklippstavlen din",
        embed: "Embed",
        link: "Link",
        menu_title: "Del"
    },
    speed: {
        menu_title: "Hastighet"
    }
};

var nl = {
    ads: {
        ad: "Ad",
        ads: "Ads",
        advertisement: "Advertentie",
        indicator: "Ads"
    },
    audio: {
        button_txt: "Audio",
        menu_title: "Audio"
    },
    cc: {
        button: "CC",
        menu_title: "Ondertiteling"
    },
    core: {
        exit_fullscreen: "Sluit fullscreen",
        fullscreen: "Fullscreen",
        mute: "Dempen",
        pause: "Pause",
        play: "Play",
        unmute: "Dempen opheffen",
        volume: "Volume"
    },
    ovp: {
        starting_in: "Start over"
    },
    playlist: {
        cancel: "Annuleren",
        up_next: "Volgende",
        autoplay: "Automatisch Afspelen"
    },
    qsel: {
        menu_title: "Kwaliteit"
    },
    share: {
        clipboard_failure: "Toegang tot klembord mislukt",
        clipboard_success: "De tekst staat nu op je klembord",
        embed: "Embed",
        link: "Link",
        menu_title: "Deel"
    },
    speed: {
        menu_title: "Snelheid"
    }
};

var nn = {
    ads: {
        ad: "Reklame",
        ads: "Reklame",
        advertisement: "Reklame",
        indicator: "Reklame"
    },
    audio: {
        button_txt: "Lydspor",
        menu_title: "Lydspor"
    },
    cc: {
        button: "CC",
        menu_title: "Teksting"
    },
    core: {
        exit_fullscreen: "Avslutt fullskjerm",
        fullscreen: "Fullskjerm",
        mute: "Skru av lyd",
        pause: "Pause",
        play: "Spel av",
        unmute: "Skru på lyd",
        volume: "Volum"
    },
    ovp: {
        starting_in: "Nedteljing"
    },
    playlist: {
        cancel: "Cancel",
        up_next: "Neste video",
        autoplay: "Automatisk Avspilling"
    },
    qsel: {
        menu_title: "Kvalitet"
    },
    share: {
        clipboard_failure: "Tilgang til utklippstavlen mislyktes",
        clipboard_success: "Teksten er no på utklippstavlen din",
        embed: "Embed",
        link: "Link",
        menu_title: "Del"
    },
    speed: {
        menu_title: "Hastighet"
    }
};

var oc = {
    ads: {
        ad: "Publicitat",
        ads: "Publicitats",
        advertisement: "Publicitat",
        indicator: "Pubs"
    },
    audio: {
        button_txt: "Àudio",
        menu_title: "Àudio"
    },
    cc: {
        button: "ST",
        menu_title: "Sostítol"
    },
    core: {
        exit_fullscreen: "Sortir de l’ecran complèt",
        fullscreen: "Ecran complèt",
        mute: "Amudir",
        pause: "Pausa",
        play: "Lectura",
        unmute: "Restablir lo son",
        volume: "Volum"
    },
    ovp: {
        starting_in: "Descompte"
    },
    playlist: {
        cancel: "Anullar",
        up_next: "Seguent",
        autoplay: "Jòc Automatic"
    },
    qsel: {
        menu_title: "Qualitat"
    },
    share: {
        clipboard_failure: "Fracàs de l’accès al quichapapièrs",
        clipboard_success: "Lo tèxt es copiat al quichapapièrs",
        embed: "Integrar",
        link: "Ligam",
        menu_title: "Partejar"
    },
    speed: {
        menu_title: "Velocitat"
    }
};

var pl = {
    ads: {
        ad: "Reklama",
        ads: "Reklama",
        advertisement: "Reklama",
        indicator: "Reklama"
    },
    audio: {
        button_txt: "Audio",
        menu_title: "Audio"
    },
    cc: {
        button: "CC",
        menu_title: "Napisy"
    },
    core: {
        exit_fullscreen: "Wyjdź z pełnego ekranu",
        fullscreen: "Pełny ekran",
        mute: "Wyciszenie",
        pause: "Pauza",
        play: "Odtwarzaj",
        unmute: "Wyłącz wyciszenie",
        volume: "Głośność"
    },
    ovp: {
        starting_in: "Countdown"
    },
    playlist: {
        cancel: "Anuluj",
        up_next: "Następny",
        autoplay: "Autoodtwarzanie"
    },
    qsel: {
        menu_title: "Jakość"
    },
    share: {
        clipboard_failure: "Błąd dostępu do schowka",
        clipboard_success: "Kod embedu jest teraz w twoim schowku.",
        embed: "Osadź",
        link: "Link",
        menu_title: "Share"
    },
    speed: {
        menu_title: "Prędkość"
    }
};

var pt = {
    ads: {
        ad: "Anúncio",
        ads: "Anúncios",
        advertisement: "Anúncio",
        indicator: "Anúncios"
    },
    audio: {
        button_txt: "Áudio",
        menu_title: "Áudio"
    },
    cc: {
        button: "CC",
        menu_title: "Subtítulos"
    },
    core: {
        exit_fullscreen: "Tela não cheia",
        fullscreen: "Tela cheia",
        mute: "Silenciar",
        pause: "Pausa",
        play: "Reproduzir",
        unmute: "Não silenciado",
        volume: "Volume"
    },
    ovp: {
        starting_in: "Countdown"
    },
    playlist: {
        cancel: "Cancelar",
        up_next: "A seguir",
        autoplay: "Reprodução Automática"
    },
    qsel: {
        menu_title: "Qualidade"
    },
    share: {
        clipboard_failure: "Falha no acesso à área de transferência",
        clipboard_success: "O código de inserção está agora na sua área de transferência",
        embed: "Embutir",
        link: "Link",
        menu_title: "Compartilhar"
    },
    speed: {
        menu_title: "Velocidade"
    }
};

var sk = {
    ads: {
        ad: "Reklama",
        ads: "Reklamy",
        advertisement: "Reklama",
        indicator: "Reklamy"
    },
    audio: {
        button_txt: "Audio",
        menu_title: "Audio"
    },
    cc: {
        button: "CC",
        menu_title: "Titulky"
    },
    core: {
        exit_fullscreen: "Vypnúť režim celej obrazovky",
        fullscreen: "Zapnúť režim celej obrazovky",
        mute: "Vypnúť zvuk",
        pause: "Pauza",
        play: "Prehrať",
        unmute: "Zapnúť zvuk",
        volume: "Hlasitosť"
    },
    ovp: {
        starting_in: "Countdown"
    },
    playlist: {
        cancel: "Cancel",
        up_next: "Ďalšie",
        autoplay: "Automatické Prehrávanie"
    },
    qsel: {
        menu_title: "Kvalita"
    },
    share: {
        clipboard_failure: "Access to clipboard failed",
        clipboard_success: "Kód na stránku je teraz vo vašej schránke",
        embed: "Kód na stránku",
        link: "Odkaz",
        menu_title: "Zdieľať"
    },
    speed: {
        menu_title: "rRýchlosť"
    }
};

var sv = {
    ads: {
        ad: "Reklam",
        ads: "Reklam",
        advertisement: "Reklam",
        indicator: "Reklam"
    },
    audio: {
        button_txt: "Ljud",
        menu_title: "Ljud"
    },
    cc: {
        button: "CC",
        menu_title: "Undertexter"
    },
    core: {
        exit_fullscreen: "Avsluta helskärm",
        fullscreen: "Helskärm",
        mute: "Ljud av",
        pause: "Paus",
        play: "Spela",
        unmute: "Ljud på",
        volume: "Volym"
    },
    ovp: {
        starting_in: "Börjar om"
    },
    playlist: {
        cancel: "Avbryt",
        up_next: "Nästa",
        autoplay: "Autouppspelning"
    },
    qsel: {
        menu_title: "Kvalitet"
    },
    share: {
        clipboard_failure: "Åtkomst till Urklipp misslyckades",
        clipboard_success: "Inbäddningskoden är nu kopierad",
        embed: "Bädda in",
        link: "Länk",
        menu_title: "Dela"
    },
    speed: {
        menu_title: "Hastighet"
    }
};

var tlh = {
    ads: {
        ad: "'chel",
        ads: "tlhaw'DIyuS",
        advertisement: "'uQ'a'",
        indicator: "chel"
    },
    audio: {
        button_txt: "qaStaHvIS",
        menu_title: "qaStaHvIS"
    },
    cc: {
        button: "CC",
        menu_title: "qeylIS"
    },
    core: {
        exit_fullscreen: "tlhoy'",
        fullscreen: "che'",
        mute: "jaS",
        pause: "yev",
        play: "chu'",
        unmute: "Huy'vam",
        volume: "muq"
    },
    ovp: {
        starting_in: "qornel"
    },
    playlist: {
        cancel: "qil",
        up_next: "Hu'",
        autoplay: "ngI'"
    },
    qsel: {
        menu_title: "boqral"
    },
    share: {
        clipboard_failure: "SengDaj LopmeH mIv'a'",
        clipboard_success: "che'rup neH 'oH buStaHvIS.",
        embed: "tlhIlwI'",
        link: "Hol",
        menu_title: "SaH"
    },
    speed: {
        menu_title: "pIp"
    }
};

var tr = {
    ads: {
        ad: "Reklam",
        ads: "Reklamlar",
        advertisement: "Reklam",
        indicator: "Reklamlar"
    },
    audio: {
        button_txt: "Ses",
        menu_title: "Ses"
    },
    cc: {
        button: "CC",
        menu_title: "Altyazılar"
    },
    core: {
        exit_fullscreen: "Tam ekrandan çık",
        fullscreen: "Tam ekran",
        mute: "Sessiz",
        pause: "Duraklat",
        play: "Oynat",
        unmute: "Sesi aç",
        volume: "Ses"
    },
    ovp: {
        starting_in: "Geri sayım"
    },
    playlist: {
        cancel: "İptal",
        up_next: "Sonraki",
        autoplay: "Otomatik Oynatma"
    },
    qsel: {
        menu_title: "Kalite"
    },
    share: {
        clipboard_failure: "Panoya erişim başarısız oldu",
        clipboard_success: "Metin panoya kopyalandı",
        embed: "Yerleştir",
        link: "Bağlantı",
        menu_title: "Paylaş"
    },
    speed: {
        menu_title: "Hız"
    }
};

var zh = {
    ads: {
        ad: "广告",
        ads: "广告",
        advertisement: "广告",
        indicator: "广告",
    },
    audio: {
        button_txt: "声音",
        menu_title: "声音",
    },
    cc: {
        button: "CC",
        colors: {
            Black: "黑色",
            Blue: "蓝色",
            Cyan: "青色",
            Green: "绿色",
            Magenta: "品红色",
            Red: "红色",
            White: "白色",
            Yellow: "黄色",
        },
        edgeStyle: {
            "Depressed": "凹陷",
            "Drop shadow": "阴影",
            "None": "无",
            "Outline": "描边",
            "Raised": "突出",
        },
        fontFamily: {
            "Casual": "休闲",
            "Cursive": "书法",
            "Monospaced Sans-Serif": "等宽无衬线",
            "Monospaced Serif": "等宽衬线",
            "Proportional Sans-Serif": "比例无衬线",
            "Proportional Serif": "比例衬线",
        },
        menu_title: "字幕",
        options: "选项",
        properties: {
            backgroundColor: "背景色",
            backgroundOpacity: "背景透明度",
            characterEdgeStyle: "样式",
            fontColor: "颜色",
            fontFamily: "字体",
            fontOpacity: "透明度",
            fontSize: "大小",
        },
        reset: "重置字幕设置",
        tracks: "轨道",
    },
    chromecast: {
        start: "开始投屏",
        stop: "停止投屏",
    },
    core: {
        exit_fullscreen: "退出全屏",
        fullscreen: "全屏",
        mute: "静音",
        pause: "暂停",
        play: "播放",
        seconds: "秒",
        timeline_aria_label: "调整播放进度",
        unmute: "取消静音",
        volume: "音量",
    },
    ovp: {
        starting_in: "倒计时",
    },
    playlist: {
        cancel: "取消",
        up_next: "即将播放",
        autoplay: "自动播放"
    },
    qsel: {
        menu_title: "清晰度",
    },
    share: {
        clipboard_failure: "无法复制到剪贴板",
        clipboard_success: "已复制到剪贴板",
        embed: "嵌入",
        link: "链接",
        menu_title: "分享",
    },
    speed: {
        menu_title: "倍速",
    },
    vtsel: {
        button_txt: "视频",
        menu_title: "视频轨道",
    },
};

var hi = {
    ads: {
        ad: "विज्ञापन",
        ads: "विज्ञापन",
        advertisement: "विज्ञापन",
        indicator: "विज्ञापन"
    },
    audio: {
        button_txt: "ऑडियो",
        menu_title: "ऑडियो"
    },
    cc: {
        button: "सीसी",
        menu_title: "सबटाइटल्स",
        options: "विकल्प",
        tracks: "ट्रैक",
        reset: "रीसेट",
        colors: {
            Black: "काला",
            Blue: "नीला",
            Cyan: "सियान",
            Green: "हरा",
            Magenta: "मैजेंटा",
            Red: "लाल",
            White: "सफ़ेद",
            Yellow: "पीला",
        },
        edgeStyle: {
            None: "कोई नहीं",
            "Drop shadow": "छाया",
            Raised: "ऊँचा",
            Depressed: "नीचा",
            Outline: "आउटलाइन"
        },
        fontFamily: {
            "Monospaced Serif": "मोनोस्पेस्ड सेरिफ़",
            "Proportional Serif": "प्रोर्पोर्शनल सेरिफ़",
            "Monospaced Sans-Serif": "मोनोस्पेस्ड सैन्स-सेरिफ़",
            "Proportional Sans-Serif": "प्रोर्पोर्शनल सैन्स-सेरिफ़",
            Casual: "कैज़ुअल",
            Cursive: "हस्तलिखित",
        },
        properties: {
            fontFamily: "फ़ॉन्ट परिवार",
            fontSize: "फ़ॉन्ट आकार",
            fontColor: "फ़ॉन्ट रंग",
            fontOpacity: "फ़ॉन्ट अस्पष्टता",
            backgroundColor: "पृष्ठभूमि रंग",
            backgroundOpacity: "पृष्ठभूमि अस्पष्टता",
            characterEdgeStyle: "कैरेक्टर एज शैली",
        }
    },
    chromecast: {
        start: "कास्टिंग शुरू करें",
        stop: "कास्टिंग रोकें"
    },
    core: {
        exit_fullscreen: "फ़ुल स्क्रीन से बाहर निकलें",
        fullscreen: "फ़ुल स्क्रीन",
        mute: "म्यूट",
        pause: "पॉज़",
        play: "प्ले",
        seconds: "सेकंड",
        timeline_aria_label: "सीक स्लाइडर",
        unmute: "अनम्यूट",
        volume: "वॉल्यूम",
        close: "बंद करें",
        "skip-next": "अगला",
        "skip-prev": "पिछला"
    },
    ovp: {
        starting_in: "काउंटडाउन"
    },
    playlist: {
        cancel: "रद्द करें",
        up_next: "अगला",
        autoplay: "स्वचालित प्ले",
        now_playing: "अभी प्ले हो रहा है",
    },
    qsel: {
        menu_title: "गुणवत्ता"
    },
    share: {
        clipboard_failure: "क्लिपबोर्ड तक पहुँच असफल",
        clipboard_success: "पाठ अब आपके क्लिपबोर्ड पर है",
        embed: "एम्बेड करें",
        link: "लिंक",
        menu_title: "साझा करें"
    },
    speed: {
        menu_title: "गति"
    },
    vtsel: {
        button_txt: "वीडियो",
        menu_title: "वीडियो ट्रैक"
    }
};

export { cs, de, en, es, fi, fr, gr, he, hi, nb, nl, nn, oc, pl, pt, sk, sv, tlh, tr, zh };
